import { BaseLayoutFactory } from '../components/base-layout-factory';
import PageNotFound from './page-not-found';

export function PageNotFoundFactory() {
    return (
        <BaseLayoutFactory>
            <PageNotFound />
        </BaseLayoutFactory>
    );
}
